import AppRouter from "./AppRouter";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "./service/axiosInstance";
import env from "react-dotenv";

function App() {
  const [minHeight, setMinHeight] = useState(0);
  const headerRef = useRef(null);
  const footerRef = useRef(null);

  const [socialIcons, setSocialIcons] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [footerLink, setFooterLink] = useState([]);
  const [logoImg, setLogo] = useState({});
  const [leftBannerLogo, setLeftBannerLogo] = useState(null);
  const [footerCount, setfooterCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [thumbnail, setThumbnail] = useState([]);
  const [headerColor, setHeaderColor] = useState(null);

  useEffect(() => {
    const fetchThemeConf = async () => {
        try {
            const customThemeRes = await axiosInstance.get(`sso-custom-page-masters?populate=*&filters[Client_ID]=${env.KEYCLOAK_CLIENT_ID}`);
            setfooterCount(customThemeRes.data.data.filter(item => item.attributes.Section === "Footer").length);
            setSocialIcons([]);
            setHeaders([]);
            setFooterLink([]);
            setLeftBannerLogo(null);
            let backgroundImage = null;
            let headerL = [], footerT = [], footerL = [];
            customThemeRes.data.data.forEach((theme) => {
                if (theme.attributes.Section === 'Footer' && theme.attributes.Type === 'Image') {
                    setSocialIcons(prevData => [...prevData, theme.attributes]);
                }
                
                if (theme.attributes.Section === 'Footer' && !theme.attributes.Title.includes('Follow us on') && theme.attributes.Type !== 'Image') {
                    footerL.push(theme.attributes);
                }

                if (theme.attributes.Section === 'Footer' && theme.attributes.Type === 'Text' && !theme.attributes.Title.includes('Follow us on')) {
                  footerT.push(theme.attributes);
                }

                if (theme.attributes.Section === 'Header' && theme.attributes.Type !== 'Logout') {
                  headerL.push(theme.attributes);
                }
                if (theme.attributes.Section === 'Header' && theme.attributes.Type === 'Logout' && theme.attributes.Color) {
                  setHeaderColor(theme.attributes.Color);
                  document.body.style.setProperty('--primary', theme.attributes.Color);
                }

                if (theme.attributes.Section === 'Login' && theme.attributes.Type === 'Logo') {
                  setLogo({ Image_Path: theme.attributes.Image_Path, alt: theme.attributes.Type });
                }

                if(theme.attributes.Type === 'Background' && !theme.attributes.Section && theme.attributes.Image_Path) {
                  if(theme.attributes.Sequence === 1) {
                    setLeftBannerLogo(theme.attributes.Image_Path);
                  }
                  if(theme.attributes.Sequence === 2) {
                    backgroundImage = theme.attributes.Image_Path;
                  }
                }
            });
            
            headerL.sort((a, b) => a.Sequence - b.Sequence);
            setHeaders(headerL);

            footerL.sort((a, b) => a.Sequence - b.Sequence);
            setFooterLink(footerL);
            if (backgroundImage) {
              document.body.style.backgroundImage = `url('${backgroundImage}')`;
              document.body.style.backgroundSize = '100% auto';
              document.body.style.backgroundRepeat = 'top right';
              document.body.style.backgroundPosition = 'center';
            }

        } catch (e) {
            console.error("customThemeRes", e);
        }
        
      };
      const fetchThumbnail = async () => {
        try {
          const customThumbnailsRes = await axiosInstance.get(`sso-thumbnail-masters?sort[0]=Sequence:asc`);
          const thumbnailData = [];
          customThumbnailsRes.data.data.forEach((thumbnail) => {
      
            thumbnailData.push({
              logo: thumbnail.attributes.Logo_Url,
              linkUrl: thumbnail.attributes.Link,
              text: thumbnail.attributes.Title,
            });
          });    
          setThumbnail(thumbnailData);
        } catch (e) {
          console.error("customThumbnails Error", e);
        }
      }
    Promise.all([fetchThemeConf(), fetchThumbnail()]).then(() => {
      setIsLoading(false);
    }
    ).catch((error) => {
      console.error("Error fetching data", error);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    function handleResize() {
      if (headerRef.current && footerRef.current) {
        setMinHeight(window.innerHeight - (headerRef.current.offsetHeight + footerRef.current.offsetHeight));
      } else if (footerRef.current) {
        setMinHeight(window.innerHeight - footerRef.current.offsetHeight);
      } else {
        setMinHeight(window.innerHeight);
      }
    }
    setTimeout(() => {
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, 600);
    
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header ref={headerRef} headers={headers} logoImg={logoImg} headerColor={headerColor}/>
      <main className='position-relative flex-fill d-flex flex-column justify-content-center'>
        <AppRouter leftBannerLogo={leftBannerLogo} isLoading={isLoading} thumbnail={thumbnail} headerColor={headerColor}/>
      </main>
      <Footer ref={footerRef} footerLink={footerLink}  socialIcons={socialIcons} footerCount={footerCount} />
      </div>
  );
}

export default App;
